export default __webpack_public_path__ + "static/media/mdi_user-search.8c8e9e4d.svg";